import { Injectable } from '@angular/core';
import {
  ScheduleDayUpdate,
  ScheduleTeamNameUpdate,
  ScheduleTeamShifts,
} from '@app/domain/entities/schedule.entity';
import { ScheduleRepository } from '@app/domain/repositories/schedule.repository';
import { Observable } from 'rxjs';
import { ScheduleService } from '../api-clients/schedule.service';

@Injectable()
export class ScheduleRepositoryImpl implements ScheduleRepository {
  constructor(private readonly _scheduleService: ScheduleService) {}

  getMonthlyShifts(): Observable<ScheduleTeamShifts[]> {
    return this._scheduleService.getMonthlyShifts();
  }

  updateMonthlyShifts(body: ScheduleDayUpdate[]): Observable<void> {
    return this._scheduleService.updateMonthlyShifts(body);
  }

  updateTeamNames(body: ScheduleTeamNameUpdate[]): Observable<void> {
    return this._scheduleService.updateTeamNames(body);
  }
}
